package com.stevdza.san.models

enum class Section(
    val id: String,
    val title: String,
    val subtitle: String,
    val path: String
) {
    Home(
        id = "home",
        title = "Home",
        subtitle = "",
        path = "#home"
    ),
    About(
        id = "about",
        title = "About me",
        subtitle = "",
        path = "#about"
    ),
    Portfolio(
        id = "portfolio",
        title = "My Projects",
        subtitle = "",
        path = "#portfolio"
    ),
    Likes(
        id = "likes",
        title = "Stuff I Like",
        subtitle = "",
        path = "#likes"
    ),
    Contact(
        id = "contact",
        title = "Contact me",
        subtitle = "Get in Touch",
        path = "#contact"
    ),
//    Experience(
//        id = "experience",
//        title = "Experience",
//        subtitle = "Work Experience",
//        path = "#experience"
//    ),
//    Testimonial(
//        id = "testimonial",
//        title = "Testimonial",
//        subtitle = "Happy Customers",
//        path = "#testimonial"
//    ),
//    Achievements(
//        id = "achievements",
//        title = "Achievements",
//        subtitle = "Personal Achievements",
//        path = "#achievements"
//    )
}